import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight, FiStar } from "react-icons/fi";
import Hero from "../components/Hero";
import Holidays from "../components/Holidays";
import Expertise from "../components/Expertise";
import Search from "../components/Search";
import SafariList from "../components/SafariList";

const revealUp = {
  hidden: { opacity: 0, y: 42 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: "easeOut" },
  },
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const SectionReveal = ({ children, className = "" }) => (
  <motion.div
    variants={revealUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.18 }}
    className={className}
  >
    {children}
  </motion.div>
);

const Home = () => {
  return (
    <div className="overflow-hidden bg-white">
      <Hero />

      <SectionReveal>
        <Search />
      </SectionReveal>

      <section className="relative bg-[#f6f1e7] py-20 font-[Poppins]">
        <motion.div
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#F5B731] to-transparent"
        />

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="mb-8 flex flex-col justify-between gap-5 md:flex-row md:items-end"
          >
            <div>
              <div className="mb-4 inline-flex items-center gap-2 border-l-4 border-[#F5B731] bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-[#C88804] shadow-sm">
                <FiStar />
                Featured Safaris
              </div>
              <h2 className="max-w-3xl text-4xl font-extrabold uppercase leading-tight tracking-normal text-[#082f1f] sm:text-5xl">
                Handpicked Safari Packages For Memorable Journeys
              </h2>
              <p className="mt-4 max-w-2xl text-base leading-8 text-[#5d7168]">
                Explore guest-favorite routes designed for wildlife, primates,
                landscapes, and smooth East African travel.
              </p>
            </div>

            <motion.div whileHover={{ y: -3 }} whileTap={{ scale: 0.98 }}>
              <Link
                to="/tours"
                className="inline-flex items-center gap-2 rounded-sm bg-[#082f1f] px-6 py-3 text-sm font-bold uppercase tracking-[0.14em] text-white shadow-lg transition hover:bg-[#F5B731] hover:text-[#082f1f]"
              >
                View All Tours
                <FiArrowRight />
              </Link>
            </motion.div>
          </motion.div>

          <SafariList limit={3} />
        </div>
      </section>

      <SectionReveal>
        <Holidays />
      </SectionReveal>

      <SectionReveal>
        <Expertise />
      </SectionReveal>
    </div>
  );
};

export default Home;
